module.exports = __webpack_public_path__ + "img/GH-kyujin-website002.bdaeaad8.webp";